import React, { useLayoutEffect, useState } from 'react';
import Img from 'react-image';
import { SwipeWrapper } from '../../../containers/swipeWrapper';
import { useImageSize } from '../../../hooks/useImageSize';
import { BottomDrawer } from '../../commons/bottomDrawer';
import DragDrawer from '../../commons/drawer';
import { Message } from '../../commons/message/message';
import { MapPoints } from '../../mapPoints';
import ZoomMapModal from '../../zoomMapModal';
import './index.scss';

export const MapView = ({ mapProps }) => {
  const { map, section, floor, title, isRootFloor = true } = mapProps;
  const { urlResized } = useImageSize(map);
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  useLayoutEffect(() => {
    document.getElementsByClassName('page-body-floor')[0].scrollTo(0, 0);
    if (isRootFloor) {
      sessionStorage.setItem('gaSection', 'root');
    } else {
      sessionStorage.setItem('gaSection', 'map');
    }
  }, [isRootFloor]);
  return (
    <>
      <div className={'map-view__wrapper'}>
        <div className={'map-view__header'}>
          <div className={'breadcrumbs zds-body-xs'}>
            <Message tag="span" id={section} />
            <Message tag="span" id={floor} />
            {!isRootFloor && (
              <Message tag="span" id="store.floorMap.indicator" />
            )}
          </div>
          <Message className={'zds-heading-m-highlight'} id={title} tag="p" />
        </div>
        <div className={'map-view__map'} onClick={() => setIsMapOpen(true)}>
          <Img className={'map-picture'} src={urlResized} alt="map-img" />
        </div>
        <SwipeWrapper
          classStyle={'map-view__mapInfo'}
          onTap={() => setIsDrawerOpen(true)}
          isVisible={!isDrawerOpen}
        >
          <BottomDrawer>
            <div className="mapPoints_header">
              <Message
                tag="p"
                className={'zds-heading-m-highlight'}
                id="store.floorMap.mapPoints.title"
              />
            </div>
          </BottomDrawer>
        </SwipeWrapper>
        <DragDrawer
          position={'bottom'}
          onRequestClose={() => setIsDrawerOpen(false)}
          open={isDrawerOpen}
        >
          <BottomDrawer>
            <MapPoints />
          </BottomDrawer>
        </DragDrawer>
      </div>
      <ZoomMapModal
        url={map}
        isModalOpen={isMapOpen}
        close={() => setIsMapOpen(false)}
      />
    </>
  );
};
